import { Profile } from '../src/app/interfaces/profile';

export const PROFILES: Profile[] = [
  {
    handoverId: undefined,
    wellId: '5400002971',
    wellboreId: 'l6KARXG88j',
    logId: '28Jpi',
    logIntervalId: 'ufOqg',
    eventCode: 'DON',
    wellboreNo: 'OH',
    holeSize: 8.75,
    holeSizeIsEdited: false,
    finishService: new Date('2018-02-04 11:30:00.0'),
    mdTop: 403.8,
    mdBase: 2469.8,
    service: 'IND-GR-CAL',
    comments: '',
    commmentsIsEdited: false,
    obsHoleSize: '',
    fecha: new Date('2018-02-04 00:00:00.0'),
    jobType: 'POZO ABIERTO',
    servNoInLogType: undefined,
    linkDwf: '',
  },
  {
    handoverId: undefined,
    wellId: '5400002971',
    wellboreId: 'l6KARXG88j',
    logId: '28Jpi',
    logIntervalId: 'M0oth',
    eventCode: 'DON',
    wellboreNo: 'OH',
    holeSize: 8.75,
    holeSizeIsEdited: false,
    finishService: new Date('2018-02-04 16:00:00.0'),
    mdTop: 800,
    mdBase: 2469.8,
    service: 'DEN-CNEU',
    comments: '',
    commmentsIsEdited: false,
    obsHoleSize: '**',
    fecha: new Date('2018-02-04 00:00:00.0'),
    jobType: 'POZO ABIERTO',
    servNoInLogType: undefined,
    linkDwf: '',
  },
  {
    handoverId: undefined,
    wellId: '5400002971',
    wellboreId: 'l6KARXG88j',
    logId: '28Jpi',
    logIntervalId: '7ZsKB',
    eventCode: 'DON',
    wellboreNo: 'OH',
    holeSize: null,
    holeSizeIsEdited: false,
    finishService: new Date('2018-02-05 05:30:00.0'),
    mdTop: 1147,
    mdBase: 2029,
    service: 'FT',
    comments: 'FMT - REALIZA 21 ENSAYOS - 1 SIN SELLO',
    commmentsIsEdited: false,
    obsHoleSize: '*',
    fecha: new Date('2018-02-05 00:00:00.0'),
    jobType: 'POZO ABIERTO',
    servNoInLogType: undefined,
    linkDwf: '',
  },
  {
    handoverId: undefined,
    wellId: '5400002971',
    wellboreId: 'l6KARXG88j',
    logId: '28Jpi',
    logIntervalId: 'amXda',
    eventCode: 'DON',
    wellboreNo: 'OH',
    holeSize: 8.755555,
    holeSizeIsEdited: true,
    finishService: new Date('2018-02-05 01:00:00.0'),
    mdTop: 2050,
    mdBase: 2326.5,
    service: 'FT',
    comments:
      'FTEX - REALIZA 12 ENSAYOS Y NO LOGRA SELLAR: (FALLA DE MOTORIZACION) - EDICIÓN',
    commmentsIsEdited: true,
    obsHoleSize: '',
    fecha: new Date('2018-02-05 00:00:00.0'),
    jobType: 'POZO ABIERTO',
    servNoInLogType: 1,
    linkDwf: '',
  },
];
